export default __webpack_public_path__ + "static/media/employees_11.0ecce641.png";